<template>
	<v-card
		class="rounded-0 pa-0 ma-0"
		width="100%"
		dark
		fixed
		flat
	>
		<v-tabs
			v-model="tab"
			style="width: 90%"
			:show-arrows="true"
			dark
		>
			<v-tabs-slider color="yellow" />
			<v-tab :tab-value="0">
				Settings
			</v-tab>
			<v-tab
				v-show="
					route !== '/htmlgenerator' &&
						route !== '/landingpagehtmlgenerator' &&
						route !== '/htmlimportplugin' &&
						route !== '/htmlimport' &&
						route !== '/sdk' &&
						route !== '/gallery'
				"
				:tab-value="1"
			>
				Document
			</v-tab>
			<v-tab
				v-show="route === '/emailpreview'
					|| route === '/emaileditor'
					|| route === '/gallery'
					|| route === '/variableeditor'
					|| route === '/emailthumbnail'
					|| route === '/htmlimportplugin'
				"
				:tab-value="2"
			>
				Hooks
			</v-tab>
			<v-tab
				v-show="route === '/emailpreview'
					|| route === '/emaileditor'
					|| route === '/gallery'
					|| route === '/variableeditor'
					|| route === '/emailthumbnail'
					|| route === '/htmlimportplugin'
				"
				:tab-value="3"
			>
				Methods
			</v-tab>
			<v-tab v-show="route === '/emaileditor'" :tab-value="4">
				Block Libraries
			</v-tab>
			<v-tab v-show="route === '/htmlgenerator'" :tab-value="5">
				Examples
			</v-tab>
			<v-tab v-show="route === '/htmlgenerator' || route === '/landingpagehtmlgenerator'" :tab-value="6">
				Input JSON
			</v-tab>
			<v-tab v-show="route === '/htmlgenerator' || route === '/landingpagehtmlgenerator'" :tab-value="7">
				Output HTML
			</v-tab>
			<v-tab v-show="route === '/htmlimport'" :tab-value="8">
				Input HTML
			</v-tab>
			<v-tab v-show="route === '/htmlimport'" :tab-value="9">
				Output JSON
			</v-tab>
		</v-tabs>

		<v-card
			v-show="tab === 0"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				:code="code"
				class="pa-0"
				lang="javascript"
			/>
		</v-card>

		<v-card
			v-show="tab === 1"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				:code="doc"
				class="pa-0"
				lang="javascript"
			/>
		</v-card>

		<v-card
			v-show="tab === 2"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				class="pa-0"
				lang="javascript"
				:code="hooks"
			/>
		</v-card>

		<v-card
			v-show="tab === 3"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				class="pa-0"
				lang="javascript"
				:code="methods"
			/>
		</v-card>

		<v-card
			v-show="tab === 4"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				class="pa-0"
				lang="javascript"
				:code="blockLibs"
			/>
		</v-card>

		<v-card
			v-show="tab === 5"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				class="pa-0"
				lang="html"
				:code="htmlCode"
			/>
		</v-card>

		<v-card
			v-show="tab === 6 || tab === 9"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				class="pa-0"
				lang="json"
				:code="htmlGeneratorDummyJSON"
			/>
		</v-card>

		<v-card
			v-show="tab === 7 || tab === 8"
			class="rounded-0 pa-0 ma-0"
			width="100%"
			dark
			fixed
			flat
		>
			<HighlightCode
				class="pa-0"
				lang="html"
				:code="route === '/htmlgenerator' ? getDummyHtmlDocument : getLandingPageDummyHtmlDocument"
			/>
		</v-card>

		<v-card
			v-show="snackbar"
			dark
			class="copyCard rounded-pill"
			elevation="0"
		>
			<v-card-text
				class="pa-1 px-4 success--text text-button"
			>
				Copied to Clipboard
			</v-card-text>
		</v-card>
		<v-tab>
			<v-btn
				dark
				icon
				class="copyToClipboard grey--text text--darken-1"
				@click="copyToClipboard"
			>
				<v-icon>mdi-clipboard-file-outline</v-icon>
			</v-btn>
		</v-tab>
	</v-card>
</template>

<script>
import sdkCodeGenerator from "./CodeEditor/codeGenerators/sdkCodeGenerator";
import thumbnailCodeGenerator from "./CodeEditor/codeGenerators/thumbnailCodeGenerator";
import previewCodeGenerator from "./CodeEditor/codeGenerators/previewCodeGenerator";
import emailEditorCodeGenerator from "./CodeEditor/codeGenerators/emailEditorCodeGenerator";
import megaGalleryCodeGenerator from "./CodeEditor/codeGenerators/megaGalleryCodeGenerator";
import variableEditorCodeGenerator from "./CodeEditor/codeGenerators/variableEditorCodeGenerator";
import blockLibrariesCodeGenerator from "./CodeEditor/codeGenerators/blockLibrariesCodeGenerator";
import documentCodeGenerator from "./CodeEditor/codeGenerators/documentCodeGenerator";
import htmlImportPluginCodeGenerator from "./CodeEditor/codeGenerators/htmlImportPluginCodeGenerator";
import htmlGeneratorCodeGenerator from "./CodeEditor/codeGenerators/htmlGeneratorCodeGenerator";
import landingPageHtmlGeneratorCodeGenerator from "./CodeEditor/codeGenerators/landingPageHtmlGeneratorCodeGenerator";
import htmlImportCodeGenerator from "./CodeEditor/codeGenerators/htmlImportCodeGenerator";
import dummyHtmlCodeGenerator from "./CodeEditor/codeGenerators/dummyHtmlCodeGenerator";

import previewHooksGenerator from "./CodeEditor/hooks/previewHooks";
import variableEditorHooksGenerator from "./CodeEditor/hooks/variableEditorHooks";
import emailEditorHooksGenerator from "./CodeEditor/hooks/emailEditorHooks";
import megaGalleryHooksGenerator from "./CodeEditor/hooks/megaGalleryHooks";
import thumbnailHooksGenerator from "./CodeEditor/hooks/thumbnailHooks";
import htmlImportPluginHooksGenerator from "./CodeEditor/hooks/htmlImportPluginHooks";

import thumbnailMethodsGenerator from "./CodeEditor/methods/thumbnailMethods";
import previewMethodsGenerator from "./CodeEditor/methods/previewMethods";
import emailEditorMethodsGenerator from "./CodeEditor/methods/emailEditorMethods";
import megaGalleryMethodsGenerator from "./CodeEditor/methods/megaGalleryMethods";
import variableEditorMethodsGenerator from "./CodeEditor/methods/variableEditorMethods";
import htmlImportPluginMethodsGenerator from "./CodeEditor/methods/htmlImportPluginMethods";

import { mapGetters } from "vuex";

export default {

	data: () => ({
		ignore: 0,
		snackbar: false,
		tab: 0,
		watchRouteChange: false,
	}),
	computed: {
		...mapGetters({ menus: "getMenu" }),
		...mapGetters([
			"getHtmlGeneratorConfigObject",
			"getImportPluginConfigObject",
			"getHtmlDocument",
			"getDummyHtmlDocument",
			"getDummyJSON",
			"getSize",
			"getLandingPageHtmlGeneratorConfigObject",
			"getLandingPageDummyJSON",
			"getLandingPageDummyHtmlDocument",
		]),
		route() {
			return this.$route.path;
		},
		doc() {
			return documentCodeGenerator(this.$store.state.document);
		},
		sdkCode() {
			return sdkCodeGenerator(this.$store.state.sdkConfig);
		},
		// Thumbnail
		thumbnailCode() {
			return thumbnailCodeGenerator(this.$store.getters.getThumbnailSettings, this.$store.getters.getThumbnailDimensions);
		},
		thumbnailHooks() {
			return thumbnailHooksGenerator();
		},
		thumbnailMethods() {
			return thumbnailMethodsGenerator(this.$store.getters.getThumbnailSettings);
		},
		// Preview
		previewCode() {
			return previewCodeGenerator(this.$store.getters.getPreviewConfigObject);
		},
		previewHooks() {
			return previewHooksGenerator();
		},
		previewMethods() {
			return previewMethodsGenerator(this.$store.getters.getPreviewConfigObject);
		},
		// Email Editor
		blockLibs() {
			return blockLibrariesCodeGenerator(
				this.$store.state.editorConfig.BlockLibData.blockLibsData,
				this.$store.getters.getBlockLibs,
			);
		},
		emailCode() {
			return emailEditorCodeGenerator(this.$store.getters.getEditorConfigObject);
		},
		editorHooks() {
			return emailEditorHooksGenerator();
		},
		editorMethods() {
			return emailEditorMethodsGenerator(this.$store.getters.getEditorConfigObject);
		},
		// Gallery
		galleryCode() {
			return megaGalleryCodeGenerator(this.$store.getters.getGalleryConfigObject);
		},
		galleryHooks() {
			return megaGalleryHooksGenerator();
		},
		galleryMethods() {
			return megaGalleryMethodsGenerator(this.$store.getters.getGalleryConfigObject);
		},
		// Variable Editor
		variableEditorCode() {
			return variableEditorCodeGenerator(
				this.$store.getters.getVariableEditorConfigObject,
			);
		},
		variableEditorHooks() {
			return variableEditorHooksGenerator();
		},
		variableEditorMethods() {
			return variableEditorMethodsGenerator(
				this.$store.getters.getVariableEditorConfigObject,
			);
		},
		// Html import plugin
		htmlImportPluginCode() {
			return htmlImportPluginCodeGenerator(this.getImportPluginConfigObject.settings);
		},
		htmlImportPluginHooks() {
			return htmlImportPluginHooksGenerator();
		},
		htmlImportPluginMethods() {
			return htmlImportPluginMethodsGenerator(
				this.$store.getters.getImportPluginConfigObject.settings,
			);
		},
		// Html generator
		htmlGeneratorCode() {
			if (this.$route.path === "/htmlgenerator") {
				return htmlGeneratorCodeGenerator(this.getHtmlGeneratorConfigObject);
			}
			return landingPageHtmlGeneratorCodeGenerator(this.getLandingPageHtmlGeneratorConfigObject);
		},
		htmlGeneratorDummyJSON() {
			if (this.$route.path === "/htmlgenerator") {
				return JSON.stringify(this.getDummyJSON, null, " ");
			}
			return JSON.stringify(this.getLandingPageDummyJSON, null, " ");
		},
		htmlCode() {
			if (this.$route.path === "/htmlgenerator") {
				return dummyHtmlCodeGenerator(
					this.getDummyHtmlDocument,
					this.getSize,
					this.getHtmlGeneratorConfigObject.lineLength,
				);
			}
			return "";
		},

		// Html import
		htmlImportCode() {
			return htmlImportCodeGenerator();
		},
		// Final
		code() {
			if (this.$route.path === "/emaileditor") return this.emailCode;
			else if (this.$route.path === "/sdk") return this.sdkCode;
			else if (this.$route.path === "/gallery") return this.galleryCode;
			else if (this.$route.path === "/emailpreview") return this.previewCode;
			else if (this.$route.path === "/emailthumbnail") {
				return this.thumbnailCode;
			} else if (this.$route.path === "/variableeditor") {
				return this.variableEditorCode;
			} else if (this.$route.path === "/htmlgenerator" || this.$route.path === "/landingpagehtmlgenerator") {
				return this.htmlGeneratorCode;
			} else if (this.$route.path === "/htmlimportplugin") {
				return this.htmlImportPluginCode;
			} else if (this.$route.path === "/htmlimport") {
				return this.htmlImportCode;
			} else return "//There is no code available";
		},

		hooks() {
			if (this.$route.path === "/emaileditor") return this.editorHooks;
			else if (this.$route.path === "/emailpreview") return this.previewHooks;
			else if (this.$route.path === "/gallery") return this.galleryHooks;
			else if (this.$route.path === "/variableeditor") return this.variableEditorHooks;
			else if (this.$route.path === "/emailthumbnail") return this.thumbnailHooks;
			else if (this.$route.path === "/htmlimportplugin") return this.htmlImportPluginHooks;
			else return "//There are no hooks available";
		},
		methods() {
			if (this.$route.path === "/emaileditor") return this.editorMethods;
			else if (this.$route.path === "/emailpreview") return this.previewMethods;
			else if (this.$route.path === "/gallery") return this.galleryMethods;
			else if (this.$route.path === "/variableeditor") return this.variableEditorMethods;
			else if (this.$route.path === "/emailthumbnail") return this.thumbnailMethods;
			else if (this.$route.path === "/htmlimportplugin") return this.htmlImportPluginMethods;
			else return "//There are no methods available";
		},
	},
	watch: {
		$route(to, from) {
			if (this.watchRouteChange) this.scrollCode(from, to);
		},
	},
	updated() {
		const el = document.querySelector(".v-navigation-drawer .v-tab--active");
		const style = window.getComputedStyle(el);

		if (style.display === "none") this.tab = 0;
	},
	mounted() {
		const wait = setInterval(() => {
			if (this.$store.state.sdk) {
				clearInterval(wait);
				this.scrollCode({ hash: "#home" }, this.$route);
				this.ignore = 0;
				this.watchRouteChange = true;
			}
		}, 100);
	},
	methods: {
		scrollCode(from, to) {
			if (this.ignore > 0) {
				this.ignore--;
				return;
			}

			const pageIndex = this.menus.findIndex(el => el.to === to.path.slice(1));

			if (!this.menus[pageIndex].children) return;

			const routes = this.menus[pageIndex].children;

			const toHash = to.hash;
			const fromHash = from.hash;

			let toInd = routes.findIndex(el => el.to === toHash) + 1;
			let fromInd = routes.findIndex(el => el.to === fromHash) + 1;

			if (to.hash === "#home") toInd = 0;
			if (from.hash === "#home") fromInd = 0;

			if (toInd === -1 || fromInd === -1) throw new Error("CodeEditor: Menu not found");

			const dist = Math.abs(toInd - fromInd);

			if (toInd === 0) {
				document.querySelector("code.hljs").scroll({
					top: 0,
					behavior: "smooth",
				});
			} else {
				document.querySelectorAll(".hljs-attr").forEach((c) => {
					if (c.innerHTML === routes[toInd - 1].codePropToMatch) {
						const parent = c.parentElement;
						parent.scroll({
							top: c.offsetTop,
							behavior: "smooth",
						});
					}
				});
			}

			if (dist > 1) this.ignore = dist;
		},

		copyToClipboard() {
			let str;

			switch (this.tab) {
				case 0:
					str = this.code;
					break;
				case 1:
					str = this.doc;
					break;
				case 2:
					str = this.hooks;
					break;
				case 3:
					str = this.methods;
					break;
				case 4:
					str = this.blockLibs;
					break;
				case 5:
					str = this.htmlCode;
					break;
				case 6:
				case 9:
					str = this.htmlGeneratorDummyJSON;
					break;
				case 7:
				case 8:
					str = this.$route.path === "/htmlgenerator" ? this.getDummyHtmlDocument : this.getLandingPageDummyHtmlDocument;
					break;
				default:
					str = "";
					break;
			}

			const el = document.createElement("textarea");
			el.value = str;
			el.setAttribute("readonly", "");
			el.style.position = "absolute";
			el.style.left = "-9999px";
			document.body.appendChild(el);
			el.select();
			document.execCommand("copy");
			document.body.removeChild(el);

			this.snackbar = true;

			setTimeout(() => {
				this.snackbar = false;
			}, 800);
		},
	},
};
</script>

<style>
.copyToClipboard {
	position: fixed !important;
	margin: 8px;
	right: 0;
	top: 0;
	z-index: 2;
}

.copyCard {
	position: fixed !important;
	top: 0;
	right: 0;
	width: 100%;
	text-align: right;
	z-index: 2;
	margin-right: 58px;
	margin-top: 4px;
}

.hljs {
	padding: 40px !important;
	display: block;
	height: calc(100vh - 48px);
	background: transparent;
	overflow-y: auto;
	scrollbar-width: thin;

	font-family: "Source Code Pro", monospace;
}

.hljs::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}
.hljs::-webkit-scrollbar-thumb {
	background: #757575;
	border-radius: 99999px;
}
.hljs::-webkit-scrollbar-thumb:hover {
	background: white;
}
.hljs::-webkit-scrollbar-track {
	background: transparent;
	border-radius: 99999px;
}

code {
	background-color: transparent !important;
	white-space: pre-wrap;
	overflow: auto;
}
</style>
